import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { HandleAlertsProvider } from '../../../utils/providers/handle-alerts-provider';
import { CreateBlogComponent } from '../../alerts/blog/create-blog/create-blog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlogService } from '../../../services/blog.service';
import { CreateBlogSectionComponent } from '../../alerts/blog/create-blog-section/create-blog-section.component';
import { finalize } from 'rxjs/operators';
import { SitemapService } from '../../../services/sitemap.service';

@Component({
  selector: 'app-blog-grid',
  templateUrl: './blog-grid.component.html',
  styleUrls: ['./blog-grid.component.scss']
})
export class BlogGridComponent implements OnInit {
  @Input() data: any;
  @Input() activeArrData;
  @Input() inactiveArrData;
  @Input() mantenienceSection;
  // @Output() editedData: EventEmitter<any> = new EventEmitter<any>();
  // @Output() deletedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() callUpdate: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private handleAlertsProvider: HandleAlertsProvider,
    private serviceModal: NgbModal,
    private blogService: BlogService,
    private sitemapService: SitemapService
  ) {
  }

  ngOnInit(): void {
  }

  editBlogPost(blog, section, index): any {
    const currentName = blog.title;
    let isCurrentNameChanged = null;
    const modal = this.serviceModal.open(CreateBlogComponent, {
      centered: true,
      windowClass: 'custom-modal-blog d-flex flex-column w-100 justify-content-center h-100pr'
    });
    const dataToEdit = {
      ...blog,
      typeId: section.sectionId,
      index
    };
    modal.componentInstance.sectionInfo = dataToEdit;
    modal.result.then((res) => {
      const modifiedName = res.title;
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      if (currentName.toLowerCase().trim() !== modifiedName.toLowerCase().trim()) {
        this.blogService.editBlog(res)
          // .pipe(finalize(() => this.sitemapService.generateSitemap().subscribe(res => {
          // })))
          .subscribe(response => {
            if (response.valid) {
              this.callUpdate.emit(true);
            }
          });
      } else {
        this.blogService.editBlog(res)
          .subscribe(response => {
            if (response.valid) {
              this.callUpdate.emit(true);
            }
          });
      }
    }, (reason) => {

    });
  }

  editBlogSection(section, index): any {
    const modal = this.serviceModal.open(CreateBlogSectionComponent, {
      centered: true,
      windowClass: ' d-flex flex-column w-100 justify-content-center short-modal'
    });
    const dataToEdit = {
      ...section,
      index
    };
    modal.componentInstance.sectionInfo = dataToEdit;
    modal.result.then((res) => {
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.blogService.editBlogType(res)
        .subscribe(response => {
          if (response.valid) {
            this.callUpdate.emit(true);
          }
        });
    }, (reason) => {

    });
  }

  changeBlogSectionStatus(id: number): any {
    Swal.fire({
      title: 'Actualizando información...',
      text: 'Por favor espere',
      icon: 'warning',
      backdrop: false,
    });
    Swal.showLoading();
    this.blogService.changeBlogTypeStatus(id)
      .subscribe(response => {
        if (response.valid) {
          this.callUpdate.emit(true);
        }
      });
  }

  createBlogPost(blogSectionInfo): any {
    const modal = this.serviceModal.open(CreateBlogComponent, {
      centered: true,
      windowClass: 'custom-modal-blog d-flex flex-column w-100 justify-content-center h-100pr'
    });
    // modal.componentInstance.sectionInfo = section;
    modal.componentInstance.orderId = blogSectionInfo.detail.length + 1;
    modal.componentInstance.typeId = blogSectionInfo.sectionId;
    modal.result.then((res) => {
      Swal.fire({
        title: 'Insertando información...',
        text: 'Por favor espere',
        icon: 'warning',
        backdrop: false,
      });
      Swal.showLoading();
      this.blogService.createBlog(res)
        // .pipe(finalize(() => this.sitemapService.generateSitemap().subscribe(r => {
        // })))
        .subscribe(response => {
          if (response.valid) {
            this.callUpdate.emit(true);
          }
        });
    }, (reason) => {

    });
  }

  deleteBlog(blog: any, section: any): any {
    Swal.fire({
      title: `¿Desea eliminar este blogpost? <br> <b>${blog.title}</b>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Eliminando información...',
          text: 'Por favor espere',
          icon: 'warning',
          backdrop: false,
        });
        Swal.showLoading();
        this.blogService.deleteBlog(blog.id, section.sectionId)
          .subscribe(res => {
            if (res.valid) {
              this.callUpdate.emit(true);
            }
          });
      }
    });
  }

  changeBlogStatus(id: any, sectionId: any): any {
    Swal.fire({
      title: 'Actualizando información...',
      text: 'Por favor espere',
      icon: 'warning',
      backdrop: false,
    });
    Swal.showLoading();
    this.blogService.changeBlogStatus(id, sectionId)
      .subscribe(response => {
        if (response.valid) {
          this.callUpdate.emit(true);
        }
      });
  }

  deleteBlogSection(section: any): any {
    Swal.fire({
      title: `¿Desea eliminar esta sección? <br> <b>${section.section}</b>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Eliminando información...',
          text: 'Por favor espere',
          icon: 'warning',
          backdrop: false,
        });
        Swal.showLoading();
        this.blogService.deleteTypeBlog(section.sectionId)
          .subscribe(res => {
            if (res.valid) {
              this.callUpdate.emit(true);
            }
          });
      }
    });
  }
}
